import { z } from 'zod';
import type { Response } from './response.js';

/** Validation for stored or transmitted responses. Authoring-side only. */
export const matchPairSchema = z.object({
  choiceId: z.string(),
  targetId: z.string(),
});

export const responseSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('unanswered') }),
  z.object({ kind: z.literal('choice'), choiceId: z.string() }),
  z.object({ kind: z.literal('choices'), choiceIds: z.array(z.string()) }),
  z.object({ kind: z.literal('trueFalse'), value: z.boolean() }),
  z.object({ kind: z.literal('text'), value: z.string() }),
  z.object({ kind: z.literal('numeric'), value: z.number() }),
  z.object({ kind: z.literal('matching'), pairs: z.array(matchPairSchema) }),
]);

/** Compile-time proof that the schema and the hand-written type stay in step. */
export type ParsedResponse = z.infer<typeof responseSchema>;
const _typesAgree: ParsedResponse extends Response ? true : never = true;
void _typesAgree;
